// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ALiO4","textarea":"styles_textarea__9TAXs"};